import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const apiSlice = createApi({
  reducerPath: "api",
  tagTypes: ["todos"],
  baseQuery: fetchBaseQuery({
    baseUrl: "https://ranok-fake-server.herokuapp.com",
  }),
  endpoints: (builder) => ({
    getTodos: builder.query({
      query: (filter) => {
        const { color, status } = filter;
        let query = "/todos?_sort=id&_order=desc";
        if (color.length) {
          query += `&${color.map((clr) => `color=${clr}`).join("&")}`;
        }
        if (status === "completed") {
          query += "&completed=true";
        }
        if (status === "incompleted") {
          query += "&completed=false";
        }

        return query;
      },
      providesTags: ["todos"],
    }),
    addTodo: builder.mutation({
      query: (data) => ({
        url: "/todos",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["todos"],
    }),
    deleteTodo: builder.mutation({
      query: (id) => ({
        url: `/todos/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["todos"],
    }),
    toggleStatus: builder.mutation({
      query: ({ id, completed }) => ({
        url: `/todos/${id}`,
        method: "PATCH",
        body: { completed: !completed },
      }),
      invalidatesTags: ["todos"],
    }),
    selectColor: builder.mutation({
      query: ({ id, color }) => ({
        url: `/todos/${id}`,
        method: "PATCH",
        body: { color },
      }),
      invalidatesTags: ["todos"],
    }),
    completeAllTodos: builder.mutation({
      query: (id) => ({
        url: `/todos/${id}`,
        method: "PATCH",
        body: { completed: true },
      }),
      invalidatesTags: ["todos"],
    }),
    EditTodo: builder.mutation({
      query: ({ id, data }) => ({
        url: `/todos/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["todos"],
    }),
  }),
});

export const {
  useGetTodosQuery,
  useAddTodoMutation,
  useDeleteTodoMutation,
  useToggleStatusMutation,
  useSelectColorMutation,
  useCompleteAllTodosMutation,
  useEditTodoMutation,
} = apiSlice;
